import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { authManager } from 'services/auth';
import { notificationContainer } from 'utils/notificationContainer';
import { accountLoginFinished, accountLoginRequest, logoutRequest } from './reducer';
import { ILoginRequestPayload } from './types';

// =============================================================:
function* accountLoginRequestWorker(action: PayloadAction<ILoginRequestPayload>) {
	const { login, password } = action.payload;

	try {
		yield call(authManager.passwordLogin, login, password);
	} catch {
		notificationContainer('The login or password is incorrect', 'error');
	} finally {
		yield put(accountLoginFinished());
	}
}

// =============================================================:
function* logoutRequestWorker() {
	yield call(authManager.logout);
}

// =============================================================:
export function* authSaga() {
	yield takeLatest(accountLoginRequest.type, accountLoginRequestWorker);
	yield takeLatest(logoutRequest.type, logoutRequestWorker);
}
